/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespShippingReturns_item = {
    readonly isDepositAvailable: boolean;
    readonly returnPolicy: {
        readonly buyerCopy: {
            readonly returnPolicySectionHeader: {
                readonly htmlCopy: string | null;
            } | null;
        } | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailReturnPolicy_item" | "PdpSharedDepositPaymentDetail_item" | "PdpSharedDetailShipping_item">;
    readonly " $refType": "PdpRespShippingReturns_item";
};
export type PdpRespShippingReturns_item$data = PdpRespShippingReturns_item;
export type PdpRespShippingReturns_item$key = {
    readonly " $data"?: PdpRespShippingReturns_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespShippingReturns_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespShippingReturns_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isDepositAvailable",
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "returnPolicy",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "ReturnPolicy",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "buyerCopy",
          "storageKey": null,
          "args": null,
          "concreteType": "ReturnPolicyCopy",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "returnPolicySectionHeader",
              "storageKey": null,
              "args": null,
              "concreteType": "InlineCtaCopy",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "htmlCopy",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailReturnPolicy_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDepositPaymentDetail_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_item",
      "args": null
    }
  ]
};
(node as any).hash = '6074fa2dfcea5cc8d4574067ad57c016';
export default node;
